const BLOCKED_SELECTORS = [
  "script",
  "style",
  "iframe",
  "object",
  "embed",
  "link",
  "meta",
  "base",
  "form",
  "input",
  "button",
  "textarea",
  "select",
];

const isUnsafeUrl = (value = "") => {
  const normalized = String(value).trim().toLowerCase();
  return (
    normalized.startsWith("javascript:") ||
    normalized.startsWith("data:text/html")
  );
};

export default function sanitizeRichTextHtml(html) {
  if (
    !html ||
    typeof window === "undefined" ||
    typeof DOMParser === "undefined"
  ) {
    return "";
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  doc.querySelectorAll(BLOCKED_SELECTORS.join(",")).forEach((node) => {
    node.remove();
  });

  doc.body.querySelectorAll("*").forEach((element) => {
    Array.from(element.attributes).forEach((attribute) => {
      const attrName = attribute.name.toLowerCase();
      const attrValue = attribute.value;

      if (attrName.startsWith("on") || isUnsafeUrl(attrValue)) {
        element.removeAttribute(attribute.name);
      }
    });

    if (element.tagName.toLowerCase() === "a") {
      if (isUnsafeUrl(element.getAttribute("href"))) {
        element.removeAttribute("href");
      }
      element.setAttribute("rel", "noopener noreferrer");
      if (element.getAttribute("target") === "_blank") {
        element.setAttribute("rel", "noopener noreferrer");
      }
    }
  });

  return doc.body.innerHTML;
}
